module.exports = __webpack_public_path__ + "img/لوکس.d040e4ef.jpg";